<template>
  <div :class="[banner ? 'banner' : '', discount === 0 ? 'counter' : 'counter-with-discount', counterClass]">
    <div v-if="discount && discountOnLeft" class="square discount">
      <span>{{ discount }}%</span>
      <span class="display-text">{{ discountText }}</span>
    </div>
    <div v-if="!hideDays" class="square days">
      <span class="number">{{ countdown.days }}</span>
      <span class="display-text">Days</span>
    </div>
    <div class="square hours">
      <span class="number">{{ hoursLeft }}</span>
      <span class="display-text">Hours</span>
    </div>
    <div class="square minutes">
      <span class="number">{{ countdown.minutes }}</span>
      <span class="display-text">Minutes</span>
    </div>
    <div class="square seconds">
      <span class="number">{{ countdown.seconds }}</span>
      <span class="display-text">Seconds</span>
    </div>
    <div v-if="discount && discountOnRight" class="square discount">
      <span class="number">{{ discount }}%</span>
      <span class="display-text">{{ discountText }}</span>
    </div>
  </div>
</template>

<script>
import { countDownToDate } from './utils/helper';

export default {
  props: {
    endDate: { type: Date, default: null, required: false },
    utcEndDate: { type: Date, default: null, required: false },
    banner: Boolean,
    hideDays: Boolean,
    discountOnLeft: Boolean,
    discountOnRight: Boolean,
    discount: { type: Number, required: false, default: 0 },
    discountText: { type: String, required: false, default: 'Discount' },
    counterClass: { type: String, required: false, default: '' },
  },
  data() {
    return {
      countdown: this.getCountdownToDate(),
    };
  },
  computed: {
    hoursLeft() {
      if (this.hideDays) {
        const hours = Number(24 * +this.countdown.days + +this.countdown.hours);
        if (hours === 0) {
          return '00';
        }
        if (hours !== 0 && hours < 10) {
          return `0${hours}`;
        }
        return hours;
      }
      return this.countdown.hours;
    },
  },
  created() {
    this.countdown = this.getCountdownToDate();
  },
  mounted() {
    if (this.endDate && this.endDate.toString() === 'Invalid Date') {
      return;
    }

    this.countdown = this.getCountdownToDate();

    const x = setInterval(() => {
      this.countdown = this.getCountdownToDate();
      if (!this.countdown) {
        clearInterval(x);
        this.$emit('offer-expired');
      }
    }, 1000);
  },
  methods: {
    getCountdownToDate() {
      return countDownToDate(new Date(), this.endDate || this.utcEndDate) || {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.counter-with-discount,
.counter {
  display: flex;

  .square {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-8) var(--spacing-12);
    border: 1px solid var(--main-dark-light-4);
    border-radius: 10px;
    color: var(--main-dark-light-4);

    &:not(:last-of-type) {
      margin-right: 10px;
    }

    &.number {
      font-size: 40px;
      line-height: 48px;
    }

    &.display-text {
      font-size: 14px;
      margin: 0;
    }
  }

  &.bf,
  &.filled {
    .square {
      width: 80px;
      height: 81px;
      border-radius: 10px;
      background-color: var(--main-dark);
      color: var(--main-light);
      justify-content: center;
      border: none;

      .number {
        font-size: 40px;
        line-height: 40px;
      }

      .display-text {
        font-size: 14px;
      }
    }
  }

  &.no-border .square {
    border: none !important;
  }

  &.mw {
    .square {
      background-color: var(--c-mw-2);
      color: var(--main-dark);
      border-radius: 0;

      .number {
        font-weight: 700;
      }
    }
  }

  &:not(.cfp).counter-dots {
    .square {
      position: relative;

      + .square:before {
        content: ':';
        font-size: 32px;
        line-height: 32px;
        font-weight: 400;
        position: absolute;
        top: 12px;
        right: 100%;
      }
    }
  }

  &.cfp {
    .square {
      color: var(--main-dark);
      border: none !important;
      position: relative;
      width: 70px;

      .number {
        font-size: 28px;
        line-height: 1.1;
      }

      .display-text {
        font-size: 14px;
        line-height: 1.3;
      }

      + .square:before {
        content: ':';
        font-size: 32px;
        line-height: 32px;
        font-weight: 400;
        position: absolute;
        top: 12px;
        right: 100%;
      }
    }

    &.white .square {
      color: var(--main-light);
    }

    &.cfp-pricing {
      justify-content: center;

      .square {
        border: none;
        flex: 0 0 auto;
        color: var(--main-light-shade-2);
        position: relative;
      }
    }
  }
}

@include bp($bp-laptop) {
  .counter-with-discount,
  .counter {
    &.cfp {
      .square {
        padding-left: 8px;
        padding-right: 8px;

        .display-text {
          font-size: 12px;
        }
      }
    }

    &.bf {
      .square {
        width: 67px;
        height: 76px;

        .number {
          font-size: 32px;
          line-height: 32px;
        }

        .display-text {
          font-size: 12px;
        }
      }
    }

    &.filled {
      .square {
        width: 74px;
        height: 73px;

        .number {
          font-size: 28px;
        }

        .display-text {
          font-size: 12px;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .counter-with-discount,
  .counter {
    &.cfp {
      .square {
        padding-left: 8px;
        padding-right: 8px;

        .display-text {
          font-size: 12px;
        }

        &:not(:last-of-type) {
          margin-right: var(--spacing-6);
        }
      }
    }

      &.filled {
        .square {
          width: 67px;
          height: 73px;

          .number {
            font-size: 28px;
          }

          .display-text {
            font-size: 14px;
          }
        }
      }
  }
}
</style>
